module.exports = __webpack_public_path__ + "static/Uni_Logo-bf704d2f3ebcb523099bb7db1ebba414.png";